import { Home } from "types/models";

export const canCreateInvoice = (associatedHome: Home): boolean => {
  const hasHomeOwner = !!associatedHome.users?.some(
    (user) => user.role === "HOME_OWNER"
  );

  return hasHomeOwner;
};
